(function(rediretBanner) {
	if (rediretBanner) {
		document.getElementById('i18n-redirect-close-button').addEventListener('click', function(event) {
		    event.preventDefault();
		    rediretBanner.classList.remove('i18n-redirect-banner--shown');

		    localStorage.setItem('i18n-redirect-banner-dismissed', Date.now());
		});

		var dismissed = localStorage.getItem('i18n-redirect-banner-dismissed');
		var ttl = 30 * 86400 * 1000;

		if (dismissed < (Date.now() - ttl)) {
		    rediretBanner.classList.add('i18n-redirect-banner--shown');
		}
	}
})(document.getElementById('i18n-redirect-banner'));